import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28daa686"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "HeaderSearchSuggestions" }
const _hoisted_2 = {
  key: 0,
  class: "HeaderSearchSuggestions__state"
}
const _hoisted_3 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = { class: "text-sm text-gray-400" }
const _hoisted_7 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || _ctx.failed || _ctx.suggestions.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : (_ctx.failed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorText), 1))
              : (_ctx.suggestions.length === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" По вашему запросу ничего не найдено ")
                  ], 64))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.suggestions, (suggestion, i) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: `suggestion-${i}`,
            to: `${suggestion.type.prefix}${suggestion.clientId}`,
            target: "_blank",
            class: "HeaderSearchSuggestions__suggestion block",
            onClick: _ctx.emitSelect
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(suggestion.type.name) + ": " + _toDisplayString(suggestion.clientName), 1),
                _createElementVNode("div", _hoisted_6, " от " + _toDisplayString(suggestion.clientCreatedAt), 1)
              ]),
              _createElementVNode("div", _hoisted_7, "Номер: " + _toDisplayString(suggestion.clientName), 1)
            ]),
            _: 2
          }, 1032, ["to", "onClick"]))
        }), 128))
  ]))
}